import { useGLTF } from "@react-three/drei"
import { useFrame } from "@react-three/fiber"
import { useControls } from "leva"
import { useEffect } from "react"
import * as THREE from 'three'

export default function Bicycle() {

    const model = useGLTF('./models/bike.glb')
    const nodes = model.nodes
    console.log(nodes);

    const { seat, frame, pedal, handleBar, rotationX, rotationY, rotationZ, animation } = useControls('Bicycle', {
        animation: false,
        seat: "#0A0A0A",
        handleBar: "#0A0A0A",
        frame: "#E75F31",
        pedal: "#0A0A0A",
        rotationX: { value: model.scene.rotation.x, min: - Math.PI, max: Math.PI * 2, step: 0.01 },
        rotationY: { value: model.scene.rotation.y, min: - Math.PI, max: Math.PI * 2, step: 0.01 },
        rotationZ: { value: model.scene.rotation.z, min: - Math.PI, max: Math.PI * 2, step: 0.01 },
    })

    // const [object1, setObject1] = useState()

    useEffect(() => {
        nodes.Seat.material.color.set(new THREE.Color(seat))
        nodes.Bike.material.color.set(new THREE.Color(frame))
        // nodes.Pedal_L.children[1].material.color.set(new THREE.Color(pedal))
        // nodes.Pedal_R.children[1].material.color.set(new THREE.Color(pedal))
        nodes.Pedal.children[3].material.color.set(new THREE.Color(pedal))
        nodes.Pedal.children[5].material.color.set(new THREE.Color(pedal))
        nodes.HandleBar.children[1].material.color.set(new THREE.Color(handleBar))

        model.scene.rotation.set(rotationX, rotationY, rotationZ)
    }, [seat, frame, pedal, handleBar, rotationX, rotationY, rotationZ])

    useFrame((state, delta) => {
        if (animation) {
            nodes.F_Pneu.rotation.y -= delta * 5
            nodes.B_Pneu.rotation.y -= delta * 5

            nodes.F_Raios.rotation.z -= delta * 5
            nodes.B_Raios.rotation.z -= delta * 5
            nodes.Pedal.rotation.z -= delta * 5
        }
        // nodes.Cylinder002.rotation.y -= delta * 5
        // nodes.Pedal_L.rotation.z -= delta * 5
        // nodes.Pedal_R.rotation.z -= delta * 5
    })

    return (
        <primitive
            object={model.scene}
        // ratation={[rotationX, rotationY, 0]}
        // onClick={(event) => {
        //     event.stopPropagation()
        //     console.log(event.object)
        // }}
        />
    )
}
useGLTF.preload('./models/bike.glb')